import { FormEvent } from "react";
import { X } from "lucide-react";
import { Dialog as DialogPrimitive } from "radix-ui";
import { Button } from "@/components/ui/button";
import { LoadingButton } from "@/components/ui/loading-button";
import { RoomCodeInput } from "@/components/boardblend/room-code-input";

interface JoinSessionDialogProps {
  kind?: "brainstorm" | "workshop";
  busy: boolean;
  error?: string;
  roomCode: string;
  onChange: (value: string) => void;
  onClose: () => void;
  onJoin: (code?: string) => void;
}

export function JoinSessionDialog({
  kind = "brainstorm",
  busy,
  error,
  roomCode,
  onChange,
  onClose,
  onJoin,
}: JoinSessionDialogProps) {
  function submit(event: FormEvent) {
    event.preventDefault();
    onJoin();
  }

  return (
    <DialogPrimitive.Root
      open
      onOpenChange={(open) => !open && !busy && onClose()}
    >
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="delete-dialog-overlay" />
        <DialogPrimitive.Content
          className="delete-dialog join-session-dialog"
          aria-describedby="join-session-description"
          onEscapeKeyDown={(event) => busy && event.preventDefault()}
          onInteractOutside={(event) => busy && event.preventDefault()}
        >
          <header>
            <DialogPrimitive.Title>Join a {kind}</DialogPrimitive.Title>
            <DialogPrimitive.Close asChild>
              <Button
                aria-label="Close"
                disabled={busy}
                size="icon-sm"
                variant="ghost"
              >
                <X />
              </Button>
            </DialogPrimitive.Close>
          </header>
          <DialogPrimitive.Description id="join-session-description">
            Enter the six-character room code.
          </DialogPrimitive.Description>
          <form onSubmit={submit}>
            <RoomCodeInput
              id="dashboard-room-code"
              placeholder="Room code"
              value={roomCode}
              disabled={busy}
              onChange={onChange}
              onComplete={onJoin}
            />
            {error && (
              <p className="form-error" role="alert">
                {error}
              </p>
            )}
            <div className="delete-dialog-actions">
              <LoadingButton type="submit" loading={busy}>
                Join {kind}
              </LoadingButton>
            </div>
          </form>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}
